import { NavButtonLabel } from '../../../types/Labels';

/**
 * The default ARIA label for next month button in navigation
 */
export const labelNext: NavButtonLabel = (): string => {
  return 'Go to next month';
};
